import React from 'react'
import PropTypes from "prop-types"

import "./Overlay.css"

const Overlay = ({open, onClick}) => {
   if (!open) {
      return (<div className="overlay"
                   onClick={onClick}></div>)
   }
   if (open) {
      return (<div className="overlay open"
                   onClick={onClick}></div>)
   }
}

Overlay.propTypes = {
   open: PropTypes.bool,
   onClick: PropTypes.func,
}


export default Overlay



// WEBPACK FOOTER //
// ./src/components/Overlay/Overlay.js